import React from 'react';
import { StarIcon } from 'lucide-react';

// Paste the existing Veterans For Life logo URL here (white version for dark backgrounds).
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/cPhB9KJHC7m9E4C3gSuoNG/vets4_Life_Logo.webp';
type LogoProps = {
  compact?: boolean;
};
export function Logo({
  compact = false
}: LogoProps) {
  if (LOGO_SRC) {
    return <img src={LOGO_SRC} alt="Veterans For Life — Vets helping vets since 2024" className={`-ml-3 w-auto transition-[height] duration-200 ease-out ${compact ? 'h-12' : 'h-16 md:h-20'}`} data-id="element-127" data-mp="3v6bf5ghh5o55" />;
  }
  return <span className="flex items-center gap-3 text-paper" data-id="element-128" data-mp="dsxunkxwc29s">
      <StarIcon aria-hidden="true" className="h-6 w-6 fill-paper text-paper" strokeWidth={1} data-id="element-129" data-mp="duiplbo4hn86" />
      <span className="flex flex-col leading-none" data-id="element-130" data-mp="hvm7e3pqdtc1">
        <span className="font-sans text-base font-bold tracking-[0.22em] sm:text-lg" data-id="element-131" data-mp="2yhc5py55mgbd">VETERANS FOR LIFE</span>
        <span className={`overflow-hidden text-[11px] font-medium tracking-[0.18em] text-paper/75 transition-[max-height,margin,opacity] duration-200 ease-out ${compact ? 'mt-0 max-h-0 opacity-0' : 'mt-1.5 max-h-4 opacity-100'}`} data-id="element-132" data-mp="32ks0eoxny6lf">
          VETS HELPING VETS SINCE 2024
        </span>
      </span>
    </span>;
}